import { useState } from 'react'
import { Building } from '../types'
import { DetailsModal } from './DetailsModal'
import './BuildingManagement.css'

interface BuildingManagementProps {
  buildings: Building[]
  loading?: boolean
  onAddBuilding: (building: string) => void
  onDeleteBuilding: (buildingId: string) => void
  onRefresh?: () => void
}

function BuildingManagement({ buildings, loading, onAddBuilding, onDeleteBuilding, onRefresh: _onRefresh }: BuildingManagementProps) {
  const [showAddForm, setShowAddForm] = useState(false)
  const [newBuilding, setNewBuilding] = useState('')
  const [selectedBuilding, setSelectedBuilding] = useState<Building | null>(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleRowClick = (building: Building) => {
    setSelectedBuilding(building)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setSelectedBuilding(null)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!newBuilding.trim()) {
      alert('Prosím zadejte název budovy')
      return
    }

    if (buildings.some(b => b.name.toLowerCase() === newBuilding.trim().toLowerCase())) {
      alert('Tato budova již existuje')
      return
    }

    onAddBuilding(newBuilding.trim())
    setNewBuilding('')
    setShowAddForm(false)
  }

  return (
    <div className="building-management">
      <div className="management-header">
        <h2>Správa budov</h2>
        <button 
          className="add-button"
          onClick={() => setShowAddForm(!showAddForm)}
        >
          {showAddForm ? '✕ Zrušit' : '+ Přidat budovu'}
        </button>
      </div>

      {showAddForm && (
        <div className="add-building-form">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="building">Název budovy *</label>
              <input
                type="text"
                id="building"
                value={newBuilding}
                onChange={(e) => setNewBuilding(e.target.value)}
                placeholder="Např. Budova A"
                required
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="submit-button">Přidat</button>
              <button type="button" onClick={() => setShowAddForm(false)} className="cancel-button">
                Zrušit
              </button>
            </div>
          </form>
        </div>
      )}

      {loading ? (
        <div className="loading">Načítání...</div>
      ) : (
        <div className="buildings-table-container">
          <table className="buildings-table">
            <thead>
              <tr>
                <th>Název budovy</th>
                <th>Akce</th>
              </tr>
            </thead>
            <tbody>
              {buildings.length === 0 ? (
                <tr>
                  <td colSpan={2} className="empty-message">
                    Žádné budovy
                  </td>
                </tr>
              ) : (
                buildings.map(building => (
                  <tr key={building.id} className="clickable-row" onClick={() => handleRowClick(building)}>
                    <td><strong>{building.name}</strong></td>
                    <td>
                      <button
                        className="delete-button"
                        onClick={(e) => {
                          e.stopPropagation()
                          onDeleteBuilding(building.id)
                        }}
                        title="Odstranit budovu"
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Модальное окно с детaлями */}
      {selectedBuilding && (
        <DetailsModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          title={`Budova: ${selectedBuilding.name}`}
          actions={
            <button
              className="delete-button"
              onClick={() => {
                if (confirm(`Opravdu chcete smazat budovu ${selectedBuilding.name}?`)) {
                  onDeleteBuilding(selectedBuilding.id)
                  handleCloseModal()
                }
              }}
              style={{
                background: '#dc3545',
                color: 'white',
                border: 'none',
                padding: '0.5rem 1rem',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              🗑️ Smazat budovu
            </button>
          }
        >
          <div className="details-section">
            <div className="details-grid">
              <div className="details-item">
                <div className="details-label">Název budovy</div>
                <div className="details-value"><strong>{selectedBuilding.name}</strong></div>
              </div>
              <div className="details-item">
                <div className="details-label">ID</div>
                <div className="details-value">{selectedBuilding.id}</div>
              </div>
            </div>
          </div>
        </DetailsModal>
      )}
    </div>
  )
}

export default BuildingManagement

